import { InvoicingActionTypes } from "./actionTypes";

export const getTransactions = (payload) => {
  return {
    type: InvoicingActionTypes.INVOICING_LIST_GET,
    payload: payload,
  };
};
export const getTransactionsSuccessful = (payload) => {
  return {
    type: InvoicingActionTypes.INVOICING_LIST_GET_SUCCESSFUL,
    payload: payload,
  };
};
export const getTransactionsError = (payload) => {
  return {
    type: InvoicingActionTypes.INVOICING_LIST_GET_ERROR,
    payload,
  };
};


export const getInvoices = (payload) => {
  return {
    type: InvoicingActionTypes.INVOICE_LIST_GET,
    payload: payload,
  };
};
export const getInvoicesSuccessful = (payload) => {
  return {
    type: InvoicingActionTypes.INVOICE_LIST_GET_SUCCESSFUL,
    payload: payload,
  };
};
export const getInvoicesError = (payload) => {
  return {
    type: InvoicingActionTypes.INVOICE_LIST_GET_ERROR,
    payload,
  };
};


export const getFilteredTransactions = (payload) => {
  return {
    type: InvoicingActionTypes.INVOICING_GET_FILTERED,
    payload: payload,
  };
};
export const getFilteredTransactionsSuccessful = (payload) => {
  return {
    type: InvoicingActionTypes.INVOICING_GET_FILTERED_SUCCESSFUL,
    payload: payload,
  };
};
export const getFilteredTransactionsError = (payload) => {
  return {
    type: InvoicingActionTypes.INVOICING_GET_FILTERED_ERROR,
    payload,
  };
};




export const createInvoice = (transaction) => {
  return {
    type: InvoicingActionTypes.INVOICING_CREATE,
    payload: transaction,
  };
};
export const createInvoiceSuccess = (transaction) => {
  return {
    type: InvoicingActionTypes.INVOICING_CREATE_SUCCESS,
    payload: transaction,
  };
};
export const createInvoiceError = (transaction) => {
  return {
    type: InvoicingActionTypes.INVOICING_CREATE_ERROR,
    payload: transaction,
  };
};

export const setInvoicingQuery = (payload) => {
  return {
    type: InvoicingActionTypes.SET_INVOICING_QUERY,
    payload,
  };
};

export const resetInvoicingQuery = () => {
  return {
    type: InvoicingActionTypes.RESET_INVOICING_QUERY,
  };
};

export const setInvoiceQuery = (payload) => {
  return {
    type: InvoicingActionTypes.SET_INVOICE_QUERY,
    payload,
  };
};

export const resetInvoiceQuery = () => {
  return {
    type: InvoicingActionTypes.RESET_INVOICE_QUERY,
  };
};
